import { IEmail, IGetEmailsQuery, IGetEmailsResponse, IGetReportingQuery, IGetReportingResponse, IGetReportingDownloadResponse } from "../../../interfaces/api/IEmails";
import { IGetWithMultipleUuidQuery, IGetWithUuidQuery, IMessageResponse } from "../../../interfaces/api/IQueries";
import {api} from "../api";

/**
 * it adds the emails endpoint to the api
 * 
 * @returns EmailsRepository
 */
const EmailsRepository = api.injectEndpoints({
    endpoints: (build) => ({
        getEmails: build.query<IGetEmailsResponse|IMessageResponse, IGetEmailsQuery>({
            query: (queryParameters) => {
                const { cursor, per_page, no_ikea, email, date_start, date_end, type, store } = queryParameters;

                let url = `/mails?per_page=${per_page}`;
                
                if (cursor) {
                    url += `&cursor=${cursor}`;
                } else {
                    url += `&page=1`;
                }
                
                if (no_ikea !== "") {
                    url += `&no_ikea=${no_ikea}`;
                }
                
                if (email !== "") {
                    url += `&email=${email}`;
                }
                
                if (date_start !== "") {
                    url += `&date_start=${date_start}`;
                }
                
                if (date_end !== "") {
                    url += `&date_end=${date_end}`;
                }
                
                if (type !== "all") {
                    url += `&type=${type}`;
                }
                
                if (store !== "all") {
                    url += `&store_uuid=${store}`;
                }
                
                return { url, method: "GET" };
            },          
        }),
        getOneEmail: build.query<IEmail|IMessageResponse, IGetWithUuidQuery>({
            query: (uuid) => ({url: `/mails/${uuid}`, method: "GET"}),
        }),
        postMailsResend: build.mutation<IMessageResponse, IGetWithUuidQuery>({
            query: ({ uuid }) => ({url: `/mails/${uuid}/resend`, method: "POST"}),
        }),
        getReporting: build.query<IGetReportingResponse|IMessageResponse, IGetReportingQuery>({
            query: (queryParameters) => 
            {
                const {date_start, date_end, store} = queryParameters;
                let url = `/reporting`;
                if(date_start !== "") {
                    url += `?date_start=${date_start}`;
                }
                if(date_end !== "") {
                    url += `&date_end=${date_end}`;
                }
                if(store !== "all") {
                    url += `&store_uuids[]=${store}`;
                }
                return {url: url, method: "GET"}
            }
            ,
        }),
        getReportingByStore: build.query<IGetReportingResponse|IMessageResponse, IGetWithMultipleUuidQuery>({
            query: ({uuids}) => {
                const completeUrl = uuids.join("/");
                return ({url: `/reporting/${completeUrl}`, method: "GET"})
            },
        }),
        getReportingExport: build.query<IGetReportingDownloadResponse, IGetReportingQuery>({
            query: (queryParameters) => 
                {
                    const {date_start, date_end, store} = queryParameters;
                    let url = `/reporting/export/`;
                    if(date_start !== "") {
                        url += `?date_start=${date_start}`;
                    }
                    if(date_end !== "") {
                        url += `&date_end=${date_end}`;
                    }
                    if(store !== "all") {
                        url += `&store_uuids[]=${store}`;
                    }
                    return {url: url, method: "GET"}
                }
                ,
        }),
    }),
});

export const {
    useGetEmailsQuery,
    useGetOneEmailQuery,
    usePostMailsResendMutation,
    useGetReportingQuery,
    useGetReportingByStoreQuery,
    useLazyGetReportingExportQuery
} = EmailsRepository;